import { getSocket, addSocketListener, SOCKET_EVENTS } from '@/hooks/socket';

export function listenParcelStatus(socketOrRef, handler) {
  if (!socketOrRef || typeof handler !== 'function') return () => {};
  return addSocketListener(socketOrRef, SOCKET_EVENTS.PARCEL_STATUS_UPDATE, handler);
}

export function unlistenParcelStatus() {
  // prefer the unsubscribe returned from listenParcelStatus
}

export default {
  listenParcelStatus,
  unlistenParcelStatus,
};
